var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-nav-bar',{attrs:{"title":"产品手册","left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('iframe',{staticClass:"mydom",attrs:{"id":"mydom","src":"https://docs.qq.com/doc/p/34fe82a57196c2f89e5f87e8afd6280446fb6257?dver=2.1.27246538","height":"100%","width":"100%","scrolling":"yes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }